import { type FC, Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { type MarkdownAsyncProps } from './Markdown.types';

const MarkdownLazy = loadable(
    () =>
        import(
            /* webpackChunkName: "shared-markdown" */
            './Markdown'
        )
);

export const MarkdownAsync: FC<MarkdownAsyncProps> = ({ fallback = null, ...props }) => (
    <Suspense fallback={fallback}>
        <MarkdownLazy {...props} />
    </Suspense>
);
